module.exports = __webpack_public_path__ + "water-fight.jpg?c10a16c23e1778f91a4ccf3e511768e1";